import React from "react";

// Brand X: the tip uses the Ice colour, the part "below the waterline" follows currentColor.
export function XMark({ className = "", title }) {
  return (
    <svg
      viewBox="34 48 188 160"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : "true"}
      focusable="false"
    >
      <path d="M38 52L82 52L123.2 98L79.2 98ZM174 52L218 52L176.8 98L132.8 98Z" fill="var(--brand-ice)" />
      <path d="M86.3 106L169.7 106L150 128L218 204L174 204L128 152.6L82 204L38 204L106 128Z" fill="currentColor" />
    </svg>
  );
}

// Line-built wordmark from the brand kit; never re-type "NexXsite" in a font.
export function Wordmark({ className = "" }) {
  return (
    <svg viewBox="-8 -14 517.5 108" className={className} aria-hidden="true" focusable="false">
      <path
        d="M6.65 78V2L59.85 78V2M84.55 51.4H137.75A26.6 26.6 0 1 0 131.53 68.5M162.45 24.8L200.45 78M200.45 24.8L162.45 78M219.45 2L272.65 78M272.65 2L219.45 78M330.19 30.47A18.05 13.3 0 1 0 315.4 51.4A18.05 13.3 0 1 1 300.61 72.33M358.15 24.8V78M396.15 13.4V68.5A9.5 9.5 0 0 0 405.65 78H409.45M382.85 24.8H413.25M437.65 51.4H490.85A26.6 26.6 0 1 0 484.63 68.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="13.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M349.9 5.8a8.25 8.25 0 1 0 16.49 0a8.25 8.25 0 1 0 -16.49 0Z" fill="currentColor" />
    </svg>
  );
}
